export default __webpack_public_path__ + "static/sobre-tecalis_02-e28828255c9d2a889f5809a944f53c73.png";